import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Phone, MessageSquare, Facebook } from 'lucide-react';
import Navbar from './Navbar';
import AIChatbot from './AIChatbot';

export default function Layout() {
  const location = useLocation();
  const { user } = useAuth();
  const isRegistryPage = location.pathname.startsWith('/registries/');
  const isGuestView = isRegistryPage && !user;

  return (
    <div className="min-h-screen flex flex-col bg-pastel-gradient relative">
      <div className="absolute inset-0 bg-confetti-pattern opacity-10 pointer-events-none"></div>
      {!isGuestView && <Navbar />}
      <main className={`flex-1 relative ${isGuestView ? '' : 'container-pastel py-8 mt-24'}`}>
        <Outlet />
      </main>
      {user && <AIChatbot />}
      <footer className="relative mt-auto py-12 bg-white/60 backdrop-blur-xl border-t border-white/30">
        <div className="container-pastel">
          <div className="flex flex-col items-center space-y-6">
            <div className="flex items-center">
              <img src="/blue-no-logo.png" alt="Giftyfy" className="h-20" style={{ mixBlendMode: 'multiply' }} />
            </div>
            <p className="text-gray-600 font-poppins text-center max-w-md">
              Making gift-giving delightful and memorable with elegance and sophistication.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a
                href="tel:+94779257975"
                className="relative z-20 inline-flex items-center px-6 py-3 rounded-2xl glass-effect hover:bg-white/30 transition-all duration-300 text-gray-700 hover:text-gray-900 cursor-pointer font-poppins shadow-soft-lg"
              >
                <Phone className="w-4 h-4 mr-2" />
                <span>+94 779257975</span>
              </a>
              <a
                href="https://wa.me/94779257975"
                target="_blank"
                rel="noopener noreferrer"
                className="relative z-20 inline-flex items-center px-6 py-3 rounded-2xl glass-effect hover:bg-white/30 transition-all duration-300 text-gray-700 hover:text-gray-900 cursor-pointer font-poppins shadow-soft-lg"
              >
                <MessageSquare className="w-4 h-4 mr-2" />
                <span>WhatsApp</span>
              </a>
              <a
                href="https://web.facebook.com/GiftyfyOfficial"
                target="_blank"
                rel="noopener noreferrer"
                className="relative z-20 inline-flex items-center px-6 py-3 rounded-2xl glass-effect hover:bg-white/30 transition-all duration-300 text-gray-700 hover:text-gray-900 cursor-pointer font-poppins shadow-soft-lg"
              >
                <Facebook className="w-4 h-4 mr-2" />
                <span>Facebook</span>
              </a>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-500 font-poppins">
              <Link to="/privacy-policy" className="hover:text-gray-700 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/refund-policy" className="hover:text-gray-700 transition-colors">
                Refund Policy
              </Link>
              <Link to="/terms-conditions" className="hover:text-gray-700 transition-colors">
                Terms & Conditions
              </Link>
            </div>
            <p className="text-sm text-gray-500 font-poppins">
              © {new Date().getFullYear()} Giftyfy. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
